import { Inject, Injectable } from '@angular/core';
import { GenericService } from './generic.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackExecutionService {

  urlConstants: any = {
    SHOW_RECRUITER_QUESTIONS: 'api/feedbackanswers/getrecruiterquestions',
    SAVE_RECRUITER_QUESTIONS: 'api/feedbackanswers/saverecruiterquestions',
    SAVE_JOB_MATCH_STATE: 'api/feedbackanswers/savejobmatchstate',
    GET_USER_LIST: 'api/feedbackanswers/getuserlist',
    GET_CANDIDATE_DETAILS: 'api/feedbackanswers/getcandidatedetails',
    CHECK_RECRUITER_SCREENING_STATUS: 'api/feedbackanswers/checkrecruiterscreeningstatus'
  };
  constructor(@Inject(StorageService) private StorageService:StorageService, @Inject(GenericService) private genericService: GenericService) { }

  getCandidateDetails(jobMatchId, successCallback, errorCallback) {
    this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_CANDIDATE_DETAILS + '/' + jobMatchId).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  getUserList(jobMatchId, companyId, successCallback, errorCallback) {
    this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_USER_LIST + '/' + jobMatchId + '/' + companyId).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  getRecruiterQuestions(jobMatchId, userId, companyId, meetingScheduleId, loggedInUserId, successCallback, errorCallback) {
    let url = this.StorageService.get('baseurl') + this.urlConstants.SHOW_RECRUITER_QUESTIONS + '?jobMatchId=' + jobMatchId + '&userId=' + userId + '&companyId=' + companyId;
    url = !_.isNull(meetingScheduleId) ? url + '&meetingScheduleId=' + meetingScheduleId : url;
    if (!_.isNull(loggedInUserId)) {
      url = url + "&loggedInUserId=" + loggedInUserId;
    }
    this.genericService.getObjects(url).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  saveRecruiterQuestions(feedbackExecutionResult, jobMatchId, loggedInUserId, successCallback, errorCallback) {
    let url = this.urlConstants.SAVE_RECRUITER_QUESTIONS + "/" + jobMatchId;
    if (!_.isNull(loggedInUserId)) {
      url = url + "?loggedInUserId=" + loggedInUserId;
    }
    this.genericService.addObject(url, feedbackExecutionResult).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  saveJobMatchState(listOfjobdetails, statusOfSave, questionType, successCallback, errorCallback) {
    this.genericService.addObject("api/feedbackanswers/savejobmatchstate/" + statusOfSave, listOfjobdetails).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  checkRecruiterScreeningStatus(jobMatchId, userId, companyId, successCallback, errorCallback) {
    this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.CHECK_RECRUITER_SCREENING_STATUS + '/' + jobMatchId + '/' + userId + '?companyId=' + companyId).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

}
